import { atom } from 'jotai'

/**
 * 認証状態を「セッション軸」と「challenge 軸」の 2 軸で表す。
 *
 * 旧 AuthProvider の isAuthenticated / mfaRequired / newPasswordRequired は
 * 独立した boolean 3 つだったが、実際には次の 2 軸へ分解できる。
 *
 * - session: loading(初回判定前) / unauthenticated / authenticated
 * - challenge: null / newPassword / mfa（ログイン途中で要求されている入力）
 *
 * challenge の途中状態そのもの（どのユーザーのどの試行か）は api の HttpOnly Cookie
 * （`api_auth_attempt` / `api_password_registration`）が運ぶため、クライアントは持たない。
 */
export type AuthSession = 'loading' | 'unauthenticated' | 'authenticated'
export type AuthChallengeStep = null | 'newPassword' | 'mfa'

export const authSessionAtom = atom<AuthSession>('loading')
export const authChallengeStepAtom = atom<AuthChallengeStep>(null)

// --- 旧 boolean と 1:1 対応する派生値 ---

/** 認証済みか。 */
export const isAuthenticatedAtom = atom((get) => get(authSessionAtom) === 'authenticated')

/** MFA(確認コード)入力が要求されているか。 */
export const mfaRequiredAtom = atom((get) => get(authChallengeStepAtom) === 'mfa')

/** 新パスワード設定が要求されているか。 */
export const newPasswordRequiredAtom = atom((get) => get(authChallengeStepAtom) === 'newPassword')

/** 初回のセッション判定が完了したか(旧 initialFetchDone)。 */
export const authResolvedAtom = atom((get) => get(authSessionAtom) !== 'loading')
